// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
// Entry imports
const HeroSection = require('./component-dumb')

function mapStateToProps(state) {
  return {
    slides: state.heroSection.slides
  }
}

module.exports = connect(
  mapStateToProps
)(
  withImmutableToJS(
    HeroSection
  )
)
